$(document).ready(function () {
  let isLoading = false;
  let debounceTimer;

  $(window).on("scroll", function () {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      const $grid = $("#product-grid");
      const $loader = $("[loader]");
      const $endMsg = $(".reached__to__end:last");

      const totalPages = parseInt($("[data-all-pages]").val());
      const currentPage = parseInt($("[data-this-page]").val());
      const nextUrl = $("[data-next-link]").val();

      if (isLoading || currentPage >= totalPages || $endMsg.text() !== "") return;

      const scrollPosition = $(window).scrollTop() + $(window).height();
      const triggerPoint = $grid.offset().top + $grid.outerHeight() - 200;

      if (scrollPosition >= triggerPoint) {
        isLoading = true;
        $endMsg.text("Loading more products...");
        $loader.show();

        $.ajax({
          url: nextUrl,
          type: "GET",
          dataType: "html",
          success: function (responseHTML) {
            const $response = $(responseHTML);
            const newProducts = $response.find("#product-grid").children();
            const newNextUrl = $response.find("[data-next-link]").val();
            const newPage = currentPage + 1;

            $("#product-grid").append(newProducts);
            $("[data-this-page]").val(newPage);
            $("[data-next-link]").val(newNextUrl);

            if (newPage >= totalPages) {
              $endMsg.text("You've reached the end.");
            } else {
              $endMsg.text("");
            }
          },
          complete: function () {
            $loader.hide();
            isLoading = false;
          }
        });
      }
    }, 150); // debounce scroll event by 150ms
  });
});
